@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

.input {
	padding: 0.375rem 0.75rem;
	outline: none;
	box-shadow: none !important;
	-webkit-box-shadow: none !important;
	height: 100% !important;
	font-size: Constants.$val-fontSizeSmall !important;
	border: 0 !important;
	color: Colors.$col-blackDark;
	flex: 1;
	background-color: Colors.$col-white;

	&.dollar-value {
		text-align: right;
	}

	&.percent-value {
		text-align: right;
	}

	&.numeric-value {
		text-align: start;
	}

	&.money-or-qty-value {
		text-align: end;
	}
	
	&.centered {
		text-align: center;
	}

	&.with-error {
		background-color: Colors.$col-redBackground !important;
	}

	&.isReadonly {
		background-color: Colors.$col-design-grey13;
	}

}

.error-placeholder::placeholder {
	color: Colors.$col-red !important; 
	opacity: 1; 
}

.input-wrapper {
	position: relative !important;
	display: flex;
	flex-direction: row;
	align-items: center;
	min-width: 0;
	height: 100%;

	[class^="icon-notification_status"] {
		position: absolute;
		top: 0px;
		left: 0;
		z-index: 3;
		color: Colors.$col-red;
		pointer-events: auto; 
	}

	&.isReadonly {
		background-color: Colors.$col-design-grey13;
	}

}

.readonly-field {
	padding: 0.375rem 0.75rem;
	height: 100%; 
	line-height: 1.5;
	font-size: 1rem;
	color: Colors.$col-blackDark;
	flex: 1;

	display: flex;
	align-items: center;
	min-width: 0;
	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;

	&.dollar-value,
	&.percent-value,
	&.money-or-qty-value {
		justify-content: flex-end;
	}

	&:empty::before {
		content: attr(data-placeholder);
		color: Colors.$col-greyFontLight;
	}

	&.error-placeholder:empty::before {
		color: Colors.$col-red !important;
		opacity: 1;
	}
	
}

.glyphs {
	padding: 0 Constants.$val-spacing-xs;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: Constants.$val-spacing-xs;
}
